<div class="row" soho-personalize>
  <div class="column full">

    <div class="field">
      <div class="div-spacer">
        <span class="command">{{ 'ToggleMenu' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftK' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'CommandShiftK' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'Save' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftS' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'CommandShiftS' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'PreviousRecord' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftLeftArrow' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'CommandShiftLeftArrow' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'NextRecord' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftRightArrow' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'CommandShiftRightArrow' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'FieldDefine' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftF6' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'FnF6' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'Refresh' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftF5' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'FnF5' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'Open' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlAltO' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'CommandAltO' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'FieldSelect' | translate }}</span><span class="keys">{{ 'DownArrow' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'FieldOptions' | translate }}</span>
        <span *ngIf="!isMac" class="keys">{{ 'CtrlShiftF7' | translate }}</span>
        <span *ngIf="isMac" class="keys">{{ 'FnF7' | translate }}</span>
      </div>
    </div>
  </div>
</div>
